import React, { useEffect, useState } from "react";
import "../styles/JobList.css";
import { useNavigate } from "react-router-dom";

const JobList = () => {
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("Tüm Ülkeler");
  const [selectedCity, setSelectedCity] = useState("Tüm Şehirler");
  const [selectedPosition, setSelectedPosition] = useState("Tüm Pozisyonlar");
  const [selectedDistrict, setSelectedDistrict] = useState("Tüm İlçeler");

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [positions, setPositions] = useState([]);
  const [districtsByCityId, setDistrictsByCityId] = useState({});
  const [cityNameToId, setCityNameToId] = useState({});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  let lastScrollY = 0;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);

  const handleDetayGor = async (ilanId) => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Ilan/goruntule/${ilanId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${localStorage.getItem("token")}`, // Gerekirse açarsın
        },
      });

      navigate(`/ilan/${ilanId}`);
    } catch (error) {
      console.error("Görüntüleme bildirimi başarısız:", error);
      navigate(`/ilan/${ilanId}`); // yine de detay sayfasına yönlendir
    }
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ilan/getirhepsi`)
      .then(res => res.json())
      .then(data => {
        const jobList = (data.$values || []).filter(job => job.status === true);
        setJobs(jobList);
        setFilteredJobs(jobList);

        setCountries(["Tüm Ülkeler", ...new Set(jobList.map(j => j.ilanUlkelerAdi))]);
        setCities(["Tüm Şehirler", ...new Set(jobList.map(j => j.ilanillerAdi))]);
        setPositions(["Tüm Pozisyonlar", ...new Set(jobList.map(j => j.ilanPozisyonAdi))]);

        // 🔁 İl -> İlçe eşleştirmesi (ID ile)
        const groupedDistricts = {};
        const cityMap = {};
        jobList.forEach(job => {
          const ilId = job.ilanillerId;
          const ilName = job.ilanillerAdi;
          const ilce = job.ilanIlceAdi?.trim();

          if (ilId && ilce) {
            if (!groupedDistricts[ilId]) groupedDistricts[ilId] = new Set();
            groupedDistricts[ilId].add(ilce);
          }

          if (ilName && ilId) {
            cityMap[ilName] = ilId;
          }
        });

        setDistrictsByCityId(groupedDistricts);
        setCityNameToId(cityMap);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let filtered = jobs;
    if (selectedCountry !== "Tüm Ülkeler")
      filtered = filtered.filter(job => job.ilanUlkelerAdi === selectedCountry);
    if (selectedCity !== "Tüm Şehirler")
      filtered = filtered.filter(job => job.ilanillerAdi === selectedCity);
    if (selectedDistrict !== "Tüm İlçeler")
      filtered = filtered.filter(job => job.ilanIlceAdi === selectedDistrict);
    if (selectedPosition !== "Tüm Pozisyonlar")
      filtered = filtered.filter(job => job.ilanPozisyonAdi === selectedPosition);

    setFilteredJobs(filtered);
  }, [selectedCountry, selectedCity, selectedDistrict, selectedPosition, jobs]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setIsFilterVisible(false);
      } else {
        setIsFilterVisible(true);
      }
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (loading) return <p className="loading">Veriler yükleniyor...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="job-list-container">
      <div className="filter-panel">
        <div className="filter-scroll-wrapper">
          <div className="filter-select-group scrollable-filters">
            <select value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
              {countries.map((country, i) => (
                <option key={i}>{country}</option>
              ))}
            </select>
            <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)}>
              {cities.map((city, i) => (
                <option key={i}>
                  {city === "Tüm Şehirler" ? "Tüm İller" : city}
                </option>
              ))}
            </select>
            <select value={selectedDistrict} onChange={(e) => setSelectedDistrict(e.target.value)}>
              <option>Tüm İlçeler</option>
              {selectedCity !== "Tüm Şehirler" &&
                Array.from(districtsByCityId[cityNameToId[selectedCity]] || []).map((ilce, i) => (
                  <option key={i}>{ilce}</option>
                ))}
            </select>
            <select value={selectedPosition} onChange={(e) => setSelectedPosition(e.target.value)}>
              {positions.map((position, i) => (
                <option key={i}>{position}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="filter-button-group">
          <button
            className="filter-reset"
            onClick={() => {
              setSelectedCountry("Tüm Ülkeler");
              setSelectedCity("Tüm Şehirler");
              setSelectedDistrict("Tüm İlçeler");
              setSelectedPosition("Tüm Pozisyonlar");
              setCurrentPage(1);
            }}
          >
            Temizle
          </button>
          <button className="filter-apply" onClick={() => setCurrentPage(1)}>
            Filtrele
          </button>
        </div>
      </div>


      <div className="job-list-wrapper">
        <div className="job-list">
          {currentJobs.length > 0 ? (
            currentJobs.map(job => (
              <div key={job.ilanId} className="job-card">
                <div className="job-logo">
                  <img src="/images/fulla.png" alt="İlan Görseli" />
                </div>
                <div className="job-details">
                  <h3 className="job-title">
                    {job.ilanBaslik} - {job.magazaAdi}
                  </h3>
                  <p className="job-short-description">{job.kisaAciklamasi}</p>
                  <p className="job-location">
                    📍{job.ilanUlkelerAdi} / {job.ilanillerAdi} / {job.ilanIlceAdi}
                  </p>
                  <button
                    className="job-button"
                    onClick={() => handleDetayGor(job.ilanId)}
                  >
                    Detayları Gör
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="no-job-info">Aktif iş ilanı bulunmamaktadır.</p>
          )}
        </div>
        <div className="pagination">
          {Array.from({ length: Math.ceil(filteredJobs.length / itemsPerPage) }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => setCurrentPage(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default JobList;
